export function resolveObject(object) {
    return Promise.all(Object.entries(object).map(async ([k, v,]) => [
        k,
        await v,
    ])).then(Object.fromEntries);
}
//# sourceMappingURL=resolve-object.js.map